import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=bc79b490&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc79b490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc79b490')) {
      api.createRecord('bc79b490', component.options)
    } else {
      api.reload('bc79b490', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=bc79b490&scoped=true&", function () {
      api.rerender('bc79b490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/adm/Edit.vue"
export default component.exports